import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Импорт файлов переводов
import ruTranslation from './locales/ru.json';
import enTranslation from './locales/en.json';
import kkTranslation from './locales/kk.json';

const resources = {
  ru: { translation: ruTranslation },
  en: { translation: enTranslation },
  kk: { translation: kkTranslation }
};

// Определяем начальный язык
const getInitialLanguage = () => {
  const saved = localStorage.getItem('language');
  if (saved && ['ru', 'en', 'kk'].includes(saved)) {
    return saved;
  }
  const browser = navigator.language.split('-')[0];
  if (['ru', 'en', 'kk'].includes(browser)) {
    return browser;
  }
  return 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: "en",
    interpolation: { escapeValue: false }
  });

export default i18n;